import { hotRanking } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

function TrendIcon({ trend }: { trend: string }) {
  if (trend === 'up') {
    return (
      <span className="w-5 h-5 flex items-center justify-center text-primary-500">
        <i className="ri-arrow-up-line text-base" />
      </span>
    );
  }
  if (trend === 'down') {
    return (
      <span className="w-5 h-5 flex items-center justify-center text-secondary-500">
        <i className="ri-arrow-down-line text-base" />
      </span>
    );
  }
  return (
    <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
      <i className="ri-subtract-line text-base" />
    </span>
  );
}

export default function HotRanking() {
  return (
    <section id="ranking" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="HOT BOARD"
          title="爆料热榜 TOP 10"
          desc="按阅读、转发与线索补充量综合排序，每小时更新一次。"
          actionHref="#archive"
          actionLabel="进入实锤档案"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-0">
          {hotRanking.map((item) => (
            <a
              key={item.rank}
              href="#dig"
              className="group flex items-center gap-4 py-4 border-b border-background-200 hover:border-primary-300 transition-colors"
            >
              <span
                className={`w-7 shrink-0 font-heading font-bold text-lg tabular-nums ${
                  item.rank <= 3 ? 'text-primary-500' : 'text-foreground-300'
                }`}
              >
                {String(item.rank).padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-[15px] text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <span className="mt-1 inline-block text-[11px] text-secondary-600">#{item.tag}</span>
              </div>
              <span className="shrink-0 flex items-center gap-2">
                <span className="hidden sm:inline text-xs text-foreground-400 tabular-nums">{item.heat}</span>
                <TrendIcon trend={item.trend} />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}